import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PortalProvider } from "@/context/PortalContext";
import TenantCorporate from "@/pages/TenantCorporate";
import TenantIndividual from "@/pages/TenantIndividual";
import { useI18n } from "@/context/I18nContext";
import api from "@/lib/api";

export default function TenantAdminEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useI18n();
  const base = `/tenant-admin/tenants/${id}`;
  const [accountType, setAccountType] = useState(null);
  const [name, setName] = useState("");

  useEffect(() => {
    api.get(`${base}/profile`)
      .then(({ data }) => {
        setName(data.name || data.company_name || "");
        setAccountType(data.account_type === "corporate" ? "corporate" : "individual");
      })
      .catch(() => setAccountType("individual"));
  }, [base]);

  return (
    <div data-testid="tenant-admin-edit">
      <Button variant="ghost" onClick={() => navigate("/tenants")} className="mb-4 -ml-2" data-testid="tenant-edit-back">
        <ArrowLeft className="w-4 h-4 mr-1.5" />{t("入居者一覧へ戻る")}
      </Button>
      {name && <div className="mb-4 text-sm text-muted-foreground">{t("編集中")}: <span className="font-medium text-[#0A0A0A]">{name}</span></div>}
      {accountType === null ? (
        <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-brand" /></div>
      ) : (
        <PortalProvider value={base}>
          {accountType === "corporate"
            ? <TenantCorporate onIndividual={() => setAccountType("individual")} />
            : <TenantIndividual onCorporate={() => setAccountType("corporate")} />}
        </PortalProvider>
      )}
    </div>
  );
}
